import Box from '@redbubble/design-system/src/Box';
import * as constants from '@redbubble/design-system/src/constants';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import TextLink from '@redbubble/design-system/src/TextLink';
import { FormattedMessage } from '@redbubble/next/intl';
import { kebabCase } from 'lodash';
import type { StaticImageData } from 'next/legacy/image';
import Image from 'next/legacy/image';
import React from 'react';

import styles from './TrustSignal.module.scss';

export interface TrustSignalProps {
  image: StaticImageData;
  imageAlt: string;
  title: string;
  description: string;
  link: string;
  linkText: string;
}

export const TrustSignal = ({
  image,
  imageAlt,
  title,
  description,
  link,
  linkText,
}: TrustSignalProps) => (
  <Stack
    direction={constants.HORIZONTAL}
    spacing="m"
    element="li"
    aria-labelledby={kebabCase(title)}
  >
    <Box padding="xs" className={styles.imgWrapper}>
      <Image alt={imageAlt} layout="responsive" src={image} />
    </Box>
    <Stack>
      <Text type="display6" element="h6" id={kebabCase(title)}>
        {title}
      </Text>
      <Text type="body2">{description}</Text>
      <TextLink intent={constants.PRIMARY} href={link} target="_blank">
        <Text type="display6">
          {linkText}
          {/* 
            letting screen readers know that the link will open a new window/tab
            https://ebay.gitbook.io/mindpatterns/antipatterns/open-new-window
            https://ebay.gitbook.io/mindpatterns/appendix/faq#how-do-i-add-content-exclusively-for-screen-readers
          */}
          <span className="clipped">
            <FormattedMessage defaultMessage=" - opens in new window or tab" />
          </span>
        </Text>
      </TextLink>
    </Stack>
  </Stack>
);
